<template>
  <div>
    <div>
      <p>
        <span class="fa fa-car ml-1 text-danger"></span>
        پس از کلیک بر روی لوکیشن مسیریاب خودرا انتخاب کنید.
      </p>

      <v-card flat width="100%" height="300" class="d-flex align-center justify-center" v-if="locLoading">
        <atom-spinner :animation-duration="1000" :size="120" class="mx-auto justify-content-center" color="#ff1d5e"/>
      </v-card>

      <mapir @click.self="openMap" :zoom="17" class="col-md-12" style="width: 100%;height: 300px"
             :center="value.coordinates" :apiKey="value.apiKey">
        <mapNavigationControl position="top-right"/>
        <mapMarker :coordinates.sync="value.coordinates" color="red" readonly kind="marker">
          <template v-slot:marker>
            <v-icon>mdi-map-marker</v-icon>
          </template>
        </mapMarker>
      </mapir>
    </div>

    <div class="col-md-12 flex py-2 my-3">
      <p><span><v-icon color="red">mdi-map-marker</v-icon></span>{{ value.address }}</p>
    </div>
  </div>
</template>

<script>
import {mapGeolocateControl, mapir, mapMarker, mapNavigationControl} from "mapir-vue";
import axios from "axios";

export default {
  name: "mapShow",
  props: {
    value: {}
  },
  components: {
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl
  },
  data() {
    return {
      locLoading: false
    }
  },
  methods: {
    openMap() {
      let agent = window.navigator.userAgent
      let type = 'https://www.google.com/maps/@'

      if (agent.toLowerCase().search('android') > 0) {
        type = 'geo:'
      } else if (agent.search('iPad') > 0 || agent.search('iPhone') > 0 || agent.search('iPod') > 0) {
        type = 'maps:'
      }

      window.open(`${type}${this.value.coordinates[1]},${this.value.coordinates[0]}?q=${this.value.coordinates[1]},${this.value.coordinates[0]}`, '_blank')
    },

    getlatLng() {
      axios({
        method: 'GET',
        baseURL: 'https://map.ir/reverse',
        params: {lat: this.value.coordinates[1], lon: this.value.coordinates[0]},
        timeout: 15000,
        headers: {
          'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg',
          Accept: 'application/json',
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        this.value.address = response.data.address
      }).finally(() => this.locLoading = false)
    },

  },
  watch: {
    value: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  mounted() {
    this.getlatLng()
  }
}
</script>

<style scoped>

</style>